<script>
    export default {
        props: ['index', 'title', 'image', 'content']
    };
</script>
<template>

        <div class="reviews__slide-box">
            <div class="slide-box">
                <div class="slide-box__name">
                    <p class="name">{{title}}</p>
                </div>
                <div class="slide-box__picture"><img class="picture lazy"
                                                     :data-src="image"
                                                     :alt="title"
                                                     src="static/img/general/logo-header.png"></div>
                <div class="slide-box__paragraph" v-html="content"></div>
            </div>
        </div>

</template>
